import styled from 'styled-components';

export const ToolBar = styled.div`
    display: inline-block;
    width: 40px;
    background-color: #535353;
    padding: 10px 0;
`;